import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { WebSocketsContextProvider } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import { useAuthenticationContext } from "../../../expert/hooks/authentication/AuthenticationContext";
import { useExpertProfileContext } from "../../../expert/hooks/expert-profile/ExpertProfileContext";
import { useCommonPortalWebSocketHook } from "../../../expert/hooks/common-web-sockets/CommonPortalWebSocketHook";
export const ManagerWebSocketContext = ({
  children
}) => {
  const {
    areWebSocketsEnabled
  } = useAuthenticationContext();
  const {
    profile
  } = useExpertProfileContext();
  if (!areWebSocketsEnabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(WebSocketsContextProvider, {
    shouldConnect: !profile.loading ? true : false,
    eventProcessorHook: useCommonPortalWebSocketHook
  }, children);
};
ManagerWebSocketContext.propTypes = {
  children: PropTypes.node.isRequired
};